import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

const activeGreen = "#20B9A9";
const activeGreenBackground = "#D6F4F0";

export const usePolicyVersionBadgeStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
        },
        activeBadge: {
            backgroundColor: activeGreenBackground,
            color: activeGreen,
            fontSize: 11,
            fontWeight: theme.typography.fontWeightBold,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            paddingTop: theme.spacing(0.25),
            paddingBottom: theme.spacing(0.25),
            borderRadius: 12,
        },
    });
};
